import { SaleEditStore as SaleEditStore_at } from '../_at/stores';
import { SaleEditStore as SaleEditStore_ch } from '../_ch/stores';
import { SaleEditStore as SaleEditStore_es } from '../_es/stores';
import { SaleEditStore as SaleEditStore_fi } from '../_fi/stores';
import { SaleEditStore as SaleEditStore_gb } from '../_gb/stores';
import { SaleEditStore as SaleEditStore_it } from '../_it/stores';
import { SaleEditStore as SaleEditStore_pr } from '../_pr/stores';
import { SaleEditStore as SaleEditStore_si } from '../_si/stores';
import { SaleEditStore as SaleEditStore_vi } from '../_vi/stores';
import { SaleEditStore as SaleEditStore_za } from '../_za/stores';
import { SaleEditStore as SaleEditStore_lu } from '../_lu/stores';
import { SaleEditStore as SaleEditStore_default } from '../_default/stores';

export default class SaleEditStore {
  constructor() {
    throw new Error('Call SaleEditStore.create() instead');
  }

  static create(user, offerData, appData) {
    switch (
      (offerData ? offerData.sale_country : '') ||
      (appData ? appData.sale_country : '')
    ) {
      case 'at':
        return new SaleEditStore_at(user);
      case 'ch':
        return new SaleEditStore_ch(user);
      case 'es':
        return new SaleEditStore_es(user);
      case 'fi':
        return new SaleEditStore_fi(user);
      case 'gb':
        return new SaleEditStore_gb(user);
      case 'it':
        return new SaleEditStore_it(user);
      case 'pr':
        return new SaleEditStore_pr(user);
      case 'si':
        return new SaleEditStore_si(user);
      case 'vi':
        return new SaleEditStore_vi(user);
      case 'za':
        return new SaleEditStore_za(user);
      case 'lu':
        return new SaleEditStore_lu(user);
      default:
        return new SaleEditStore_default(user);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/@propnow/containers/Sale/SaleEditSection/stores/index.js